import { makeAutoObservable } from "mobx";

import { CompanyStore } from "services/company/companyStore";
import { IncorporationCreateData, IncorporationData } from "services/incorporation/incorporationTypes";
import { IncorporationClient } from "./incorporationClient";

export interface IIncorporationStore {
  incorporation?: IncorporationData;
  createIncorporation: () => Promise<void>;
}

export class IncorporationStore implements IIncorporationStore {
  private readonly _companyStore: CompanyStore;
  private readonly _incorporationClient: IncorporationClient;

  private _incorporation?: IncorporationData = undefined;

  constructor(incorporationClient: IncorporationClient, companyStore: CompanyStore) {
    this._incorporationClient = incorporationClient;
    this._companyStore = companyStore;

    makeAutoObservable(this);
  }

  get incorporation(): IncorporationData | undefined {
    return this._incorporation;
  }

  set incorporation(value: IncorporationData | undefined) {
    this._incorporation = value;
  }

  async init(): Promise<void> {
    this.incorporation = await this._incorporationClient.getIncorporation();
  }

  async createIncorporation(): Promise<void> {
    this.incorporation = await this._incorporationClient.createIncorporation(
      new IncorporationCreateData(this._companyStore.getCompany().id),
    );
  }
}
